import { render, staticRenderFns } from "./modalEditCompany.vue?vue&type=template&id=613246c6&scoped=true&"
import script from "./modalEditCompany.vue?vue&type=script&lang=js&"
export * from "./modalEditCompany.vue?vue&type=script&lang=js&"
import style0 from "./modalEditCompany.vue?vue&type=style&index=0&id=613246c6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "613246c6",
  null
  
)

export default component.exports